import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { DATE_FORMATS } from '@/utils/dateHelpers'
import { useAppDispatch } from '@/utils/typeHelpers'
import { selectIsFetchingForKeys } from '@/reducers/fetch'

import { Button, Image, Text, Loader } from '@/ui'
import { TypographyStyles } from '@/styles'
import { updateFinancialProfile } from '@/actions/financialProfileActions'
import { useReselector } from '@/utils/sharedHooks'
import { getFinancialProfile } from '@/selectors/user.selectors'

import { selectUserTaxCalculationWithinActiveQuarter } from '@/selectors/userTaxCalculation.selectors'
import { dateWithoutTimestamp } from '@/features/taxes/quarterly/service'
import {
  RECALCULATE_USER_TAX_CALCULATIONS_KEY,
  fetchUserTaxCalculationsIfNeeded,
  recalculateUserTaxCalculation,
} from '@/features/admin/user-tax-calculations/userTaxCalculation.slice'

export const FinishRecalculation = () => {
  const isCalculating = useReselector(selectIsFetchingForKeys, [
    RECALCULATE_USER_TAX_CALCULATIONS_KEY,
  ])

  const navigate = useNavigate()

  const fp = useReselector(getFinancialProfile)
  const calculation = useReselector(selectUserTaxCalculationWithinActiveQuarter)

  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(
      updateFinancialProfile(fp?.id, {
        taxProfileLastReviewed: dateWithoutTimestamp().format(
          DATE_FORMATS.TIMESTAMP
        ),
      })
    )
  }, [dispatch, fp?.id])

  useEffect(() => {
    dispatch(recalculateUserTaxCalculation())
  }, [dispatch, calculation?.id])

  useEffect(() => {
    dispatch(fetchUserTaxCalculationsIfNeeded(true))
  }, [dispatch])

  return (
    <div className="flex flex-col items-center gap-6 py-4 px-2">
      {isCalculating ? (
        <Loader active />
      ) : (
        <>
          <div className="flex justify-center">
            <Image
              src="https://heard-images.s3.amazonaws.com/assets/booklist.svg"
              className="w-[120px] h-[120px]"
              alt="Booklist"
            />
          </div>

          <Text
            variant={TypographyStyles.DISPLAY_LG}
            className="w-full max-w-screen-md text-center px-4"
          >
            You&apos;ve made changes to your tax information
          </Text>

          <Text
            variant={TypographyStyles.BODY_LG}
            className="w-full max-w-screen-md text-center px-4"
          >
            You&apos;ll find your new federal tax estimate in the Quarterly Tax
            Center.
          </Text>

          <Button
            variant="secondary"
            className="flex justify-center"
            onClick={() => navigate('/taxes/quarterly')}
          >
            Quarterly Tax Center
          </Button>
        </>
      )}
    </div>
  )
}
